<template>
  <div class="home">
    <meta
      data-n-head="1"
      data-hid="description"
      name="description"
      content=""
    />
    <meta data-n-head="1" data-hid="keywords" name="keywords" content="" />
    <!-- <Banner></Banner> -->
    <four4four v-if="showError"></four4four>
    <ShowTemplates :templateList="temp"></ShowTemplates>
  </div>
</template>

<script>
// @ is an alias to /src
import { getJsonById, getPageById } from "@/api/index";
import ShowTemplates from "@/components/showTemplates.vue";
// import Banner from "@/components/banner.vue";
import four4four from "./404.vue";
export default {
  name: "showpage",
  components: {
    four4four,ShowTemplates
  },

  metaInfo() {
    return {
      title: this.pageInfo.mTitle, // set a title
      meta: [
        {
          // set meta
          name: "keyWords",
          content: this.pageInfo.mSeoKey,
        },
      ],
      link: [
        {
          // set link
          rel: "description",
          href: this.pageInfo.mSeoDescription,
        },
      ],
    };
  },
  watch: {
  // 深度监听路由改变事件
  $route: {
    handler(val, oldVal) {
      let detailId = val.params.id.slice(14);
      let id = detailId.split(".");
        getJsonById({ id: id[0] })
      .then((response) => {
        this.showError = false;
        this.temp = response.data;
      })
      .catch((e) => {
        this.showError=true
      });
    },
  },
},
  created() {
    console.log(this.$route.params.id);
    let id = this.$route.params.id.split(".");
    getJsonById({ id: id[0] })
      .then((response) => {
        this.showError = false;
        this.temp = response.data;
      })
      .catch((e) => {
        this.showError=true
      });
    getPageById({ id: id[0] }).then((response) => {
      this.pageInfo = response.data;
    }).catch(e=>{
         this.pageInfo={
        mTitle:'页面错误',
        mSeoKey:'华南软件官网',
        mSeoDescription:'华南软件官网',
      }
    });
  },
  data() {
    return {
      temp: [],
      pageInfo: {},
      showError: false,
    };
  },
};
</script>




